// extracted by mini-css-extract-plugin
export default {"item":"modal_item__6tKrV","fadein":"modal_fadein__GstGh","itemFadeout":"modal_itemFadeout__ZFSt8","fadeout":"modal_fadeout__q+F35"};